import ActivityReportDirection = ToroEnums.ActivityReportDirection;
import ActivityReportType = ToroEnums.ActivityReportType;
import ActivityState = ToroEnums.ActivityState;
import ActivityStatus = ToroEnums.ActivityStatus;
import DeviceType = ToroEnums.DeviceType;

import { ToroEnums } from '@app/common/enumerations/toro.enums';


// ─── Sub-type classes ────────────────────────────────────────────────
/** Controller entry for tabs and filter panel */
export class ActivityController {
    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);
            if (json.id != null) {
                this.id = String(json.id);
            }
        }
    }

    id: string = '';
    name: string = '';
    type?: DeviceType;
}

export class ActivityDescriptionChange {
    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);
        }
    }

    property: string = '';
    oldValue: any;
    newValue: any;
    changeType: string = '';
}

export class ActivityDescription {
    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);
        }

        const rawChanges = json?.changes ?? json?.Changes;
        if (Array.isArray(rawChanges)) {
            this.changes = rawChanges.map((change: any) => new ActivityDescriptionChange(change));
        }
    }

    changes: ActivityDescriptionChange[] = [];
    controllerId: string = '';
    /** On alarm activities, the alarm's type as the controller names it, e.g. "Power On". */
    alertType?: string;
}

/** Individual activity event — view-model with UI fields */
export class ActivityItem {
    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);

            if (json.controller) {
                this.controller = new ActivityController(json.controller);
            } else if (json.controllerId != null || json.ControllerId != null) {
                this.controller = new ActivityController({
                    id: json.controllerId ?? json.ControllerId,
                    name: json.controllerName ?? json.ControllerName,
                    type: json.controllerTypeId ?? json.ControllerTypeId,
                });
            }

            if (json.description && typeof json.description === 'object' && !Array.isArray(json.description)) {
                this.description = new ActivityDescription(json.description);
            }
            if (this.status == null && this.activityStatus != null) {
                this.status = this.activityStatus;
            }
            if (this.category == null && this.activityCategory != null) {
                this.category = this.activityCategory;
            }
            if (this.subCategory == null && this.activitySubCategory != null) {
                this.subCategory = this.activitySubCategory;
            }
        }
    }

    transmissionId?: string | number;
    timestamp: string = '';
    state?: ActivityState;
    status: ActivityStatus = ActivityStatus.Unknown;
    title: string = '';
    controller?: ActivityController;
    description?: ActivityDescription;
    formattedDetails: string = '';
    transmissionDirection?: ActivityReportDirection;
    attemptCount: number = 0;
    activityType?: ActivityReportType;
    activityStatus?: ActivityStatus;
    category?: ToroEnums.ActivityCategory;
    subCategory?: ToroEnums.ActivitySubCategory;
    activityCategory?: ToroEnums.ActivityCategory;
    activitySubCategory?: ToroEnums.ActivitySubCategory;
}

// ─── Main class ──────────────────────────────────────────────────────
/** Activity Report — primary model. One instance = one report response. */
export class ActivityReport {
    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);

            const rawActivities = json.activities ?? json.Activities;
            if (rawActivities && Array.isArray(rawActivities)) {
                this.activities = rawActivities.map(
                    (a: any) => new ActivityItem(a)
                );
            }
        }
    }

    startDate: string = '';
    endDate: string = '';
    activities: ActivityItem[] = [];
    nextCursor: string | null = null;
    totalCount = 0;

    get hasMore(): boolean {
        return this.nextCursor !== null;
    }
}
